import { useLocation, useNavigate } from "react-router-dom"
import Icon from "../../base/Icon"
import Avatar from "../../base/Avatar"
import "./MobileNavBar.css"
import { canListActiveJobs, getUser, hasRole, useGlobal } from "../../../core/Global"
import { isNativeAndroidApp, isNativeiOSApp } from "../../../NativeAppBrdige"
import { jobsBoardLink } from "../../../modules/crm/jobs/utils/jobsBoardState";


interface MobileTab {
    key: string
    icon: string
    size: number
    label: string
    to: string
    match: string
    badge?: boolean
    avatar?: boolean
}

interface IProps {
    onOpenSearch: () => void
}

export default function MobileNavBar(props: IProps) {

    const navigate = useNavigate()
    const location = useLocation()
    const user = getUser()
    const [global] = useGlobal()

    const path = location.pathname.toLocaleLowerCase()

    const tabs: MobileTab[] = []

    if (canListActiveJobs()) tabs.push({
        key: "board",
        icon: "list-check",
        size: 20,
        label: "Board",
        // The board as it was left: same view, filters and Find text.
        to: jobsBoardLink(location),
        match: "/boards/jobs",
        badge: !!(user?.isTech && global.jobs?.find(f => f.jobStatusId == "pending")?.id)
    })

    tabs.push({
        key: "chat",
        icon: "message-lines",
        size: 20,
        label: "Chat",
        to: "/chat",
        match: "/chat",
        badge: !!global.techChat?.techUnread
    })

    if (user?.isTech) {
        if (hasRole("TechViewReports")) {
            tabs.push({
                key: "reports",
                icon: "chart-line",
                size: 20,
                label: "Reports",
                to: "/mobile/reports",
                match: "/mobile/reports"
            })
        }
    } else if (hasRole("HasCRM") && hasRole("JobsReport")) {
        tabs.push({
            key: "reports",
            icon: "chart-line",
            size: 20,
            label: "Reports",
            to: "/reports/jobs",
            match: "/reports"
        })
    }

    tabs.push({
        key: "account",
        icon: "user-circle",
        size: 20,
        label: "Settings",
        to: "/mobile/account",
        match: "/mobile/account",
        avatar: true
    })

    const activeIndex = tabs.findIndex(t => path.startsWith(t.match))
    const slot = 100 / tabs.length

    return (
        <>
            <div className={`mobile-navbar-wrap ${isNativeiOSApp() ? "mobile-navbar-native-ios" : ""} ${isNativeAndroidApp() ? "mobile-navbar-native-android" : ""}`}>

                <div id="mobile-tabs-bottom-navbar" className="mobile-navbar">
                    <div className="mobile-navbar-inner">

                        {activeIndex >= 0 &&
                            <div className="mobile-navbar-indicator"
                                style={{
                                    width: `${slot}%`,
                                    transform: `translateX(${activeIndex * 100}%)`
                                }}>
                                <div className="mobile-navbar-indicator-fill" />
                            </div>
                        }

                        {tabs.map(tab => {
                            const active = path.startsWith(tab.match)
                            return (
                                <div key={tab.key}
                                    className={`mobile-navbar-item ${active ? "mobile-navbar-item-active" : ""}`}
                                    onClick={() => navigate(tab.to, { replace: true })}>
                                    <div className="mobile-navbar-item-icon">
                                        {tab.avatar
                                            ? <Avatar className="mobile-navbar-avatar"
                                                avatarUrl={user?.avatarUrl}
                                                fullName={user?.fullName}
                                                width={24} textSize={11} />
                                            : <Icon icon={tab.icon} size={tab.size} />
                                        }
                                        {tab.badge && <div className="mobile-navbar-circle-badge" />}
                                    </div>
                                    <div className="mobile-navbar-item-label">
                                        {tab.label}
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </div>

                <div className="mobile-navbar-search" onClick={props.onOpenSearch}>
                    <Icon icon="magnifying-glass" size={18} />
                </div>

            </div>
        </>
    )
}
